import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { RolesList } from '../components/roles/RolesList';
import { AddRoleModal } from '../components/roles/AddRoleModal';
import { useTeamStore } from '../stores/teamStore';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ErrorMessage } from '../components/common/ErrorMessage';
import { ar } from '../locales/ar';

export const RolesPage = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { loading, error, fetchRoles } = useTeamStore();

  // Initialize roles data when component mounts
  useEffect(() => {
    const loadRoles = async () => {
      try {
        await fetchRoles();
      } catch (error) {
        console.error('Error loading roles:', error);
      }
    };

    loadRoles();
  }, [fetchRoles]);

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} onRetry={fetchRoles} />;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">{ar.roles.title}</h1>
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600 
                   transition-colors flex items-center gap-2"
        >
          <Plus size={20} />
          <span>{ar.roles.addRole}</span>
        </button>
      </div>

      <RolesList />
      
      <AddRoleModal 
        isOpen={isAddModalOpen} 
        onClose={() => setIsAddModalOpen(false)} 
      />
    </div>
  );
};